import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMapEvents } from 'react-leaflet';

function LeafletMapGuideLocation({
    onViewChanged = ()=>{},
    center = [36.109, -95.895],
}) {

    //state to hold original position
    const [originalPosition, setOriginalPosition] = React.useState(null);

    function MapClickHandler() {
        useMapEvents({
            moveend: (e) => {
                // get center of map
                onViewChanged(e.target.getCenter());
            }
        });

        return null;
    }
    // zoom={13} 

    // at start run onViewChanged with the center of the map
    // use effect
    useEffect(() => {


    setOriginalPosition(center);
     
    }
    , []);

    let maxBounds = [
        [90, -180],
        [-90, 180
        ]
    ];

    // if width is greater than 600 then allow a greater buffer on bounds
    if (window.innerWidth > 600) {
        maxBounds = [
            [120, -210],
            [-120, 210
            ]
        ];
    }

   

    return (
        <MapContainer center={center} zoom={5}
        style={{ height: "70vh", width: "100%" }}
        maxBounds={maxBounds}
        >
            <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
            <MapClickHandler />
            {/* Show a crosshair that always stays in the middle of the screen*/}
            {originalPosition &&
            <Marker position={originalPosition}>
            </Marker>
            }
            <Box
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "2rem",
                    color: "red",
                    zIndex: 1000
                
                }}
            >
                x
            </Box>
            
        </MapContainer>
    );
}

export default LeafletMapGuideLocation;